module.exports = __webpack_public_path__ + "images/help/guide_video_invite-bcb19aa99339d984f874bce348f61f42.png";